/**
 * @author TomaszCzura ({}
 */
import React from 'react';
import PropTypes from 'prop-types';
import UsersList from './UsersList';
import WhitePortlet from '../utils/WhitePortlet';
import RoleBasedComponent from '../utils/RoleBasedComponent';
import * as rights from '../../model/rights';
import i18next from 'i18next';
import * as usersApi from './../../api/users-api';
import {connect} from 'react-redux';
import ErrorBox from './../utils/ErrorBox';
import {getErrorDescription} from '../../utils/view-utils';
import * as blockUtils from '../../utils/BlockUtils';
import {DataTypes} from '../../model/utils';

class UsersListContainer extends RoleBasedComponent {
  constructor(props) {
    super(props);

    this.tableId = 'users_table';

    this.onDataTypeChange = this.onDataTypeChange.bind(this);
    this.getData = this.getData.bind(this);

    this.dataType = DataTypes.ACTIVE;
    this.pageNumber = 0;
    this.elementsCount = 10;
    this.sortingName = 'username';
    this.sortingType = 'asc';
    this.searchPhrase = '';
  }

  componentDidMount() {
    const data = {
      pageNumber: this.pageNumber,
      size: this.elementsCount,
      query: this.searchPhrase,
      sort: `${this.sortingName},${this.sortingType.toLowerCase()}`,
      showDisabledUsers: this.dataType === DataTypes.HISTORICAL,
    };

    this.checkRights(() => usersApi.getUsers(data));
    usersApi.getUserProfile();
  }

  getRights() {
    return rights.USER_READ_PRIVILEGE;
  }

  getData(
      pageNumber = this.pageNumber,
      elementsCount = this.elementsCount,
      sortingName = this.sortingName,
      sortingType = this.sortingType,
      searchPhrase = this.searchPhrase,
  ) {
    const data = {
      page: pageNumber,
      size: elementsCount,
      query: searchPhrase,
      sort: `${sortingName},${sortingType.toLowerCase()}`,
    };

    usersApi.getUsers(data).then(() => blockUtils.unblockUI(`#${this.tableId}`)).catch();
    blockUtils.blockUI(`#${this.tableId}`);

    this.pageNumber = pageNumber;
    this.elementsCount = elementsCount;
    this.sortingName = sortingName;
    this.sortingType = sortingType;
    this.searchPhrase = searchPhrase;
  }

  onDataTypeChange(dataType) {
    this.dataType = dataType;
    this.getData(this.pageNumber, this.elementsCount, this.sortingName, this.sortingType, this.searchPhrase);
  }

  render() {
    return (
      <WhitePortlet
        caption={i18next.t('users.name', {count: 2})}
        actionsType={'active-switch'}
        icon="icon-users"
      >
        <ErrorBox errorMessage={getErrorDescription(this.props.getUsersError)}/>
        <ErrorBox errorMessage={getErrorDescription(this.props.destroyUserError)}/>

        <UsersList
          users={this.props.users}
          getData={this.getData}
          tableId={this.tableId}
          totalPages={this.props.totalPages}
          totalElements={this.props.totalElements}
          defaultSort={[1, 'asc']}
          createUserError={this.props.createUserError}
          availableRoles={this.props.userProfile.availableRoles}
        />
      </WhitePortlet>
    );
  }
}

UsersListContainer.propTypes = {
  users: PropTypes.array,
  error: PropTypes.any,
  onPageChange: PropTypes.func,
  onElementsCountChange: PropTypes.func,
  totalElements: PropTypes.number,
  totalPages: PropTypes.number,
  elementsCount: PropTypes.number,
};
UsersListContainer.defaultProps = {
  getUsersError: PropTypes.object,
  destroyUserError: PropTypes.object,
  createUserError: PropTypes.object,
};

const mapStateToProps = function(store) {
  return {
    users: store.usersState.users,
    destroyUserError: store.usersState.destroyUserError,
    createUserError: store.usersState.createUserError,
    getUsersError: store.usersState.getUsersError,
    userProfile: store.usersState.userProfile,
    totalPages: store.usersState.totalPages,
    totalElements: store.usersState.totalElements,
  };
};

export default connect(mapStateToProps)(UsersListContainer);
